import { render, staticRenderFns } from "./ComeAndHelp.vue?vue&type=template&id=84cf0e10&scoped=true&"
import script from "./ComeAndHelp.vue?vue&type=script&lang=js&"
export * from "./ComeAndHelp.vue?vue&type=script&lang=js&"
import style0 from "./ComeAndHelp.vue?vue&type=style&index=0&id=84cf0e10&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84cf0e10",
  null
  
)

export default component.exports